import { Card, Container } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";

const pages = {
  privacy: {
    title: "Politica de privacidad",
    intro: "Cardora trata datos para crear comunidad entre coleccionistas, tiendas y eventos TCG.",
    sections: [
      ["Responsable", "Cardora / Ninnotech. El contacto operativo es notificaciones@cardora.ninnotech.com."],
      ["Datos que podemos tratar", "Cuenta, email, nombre visible, avatar, ubicacion aproximada, publicaciones, cartas subidas, imagenes, binders, trades, mensajes, valoraciones, notificaciones y actividad basica de uso."],
      ["Finalidad", "Gestionar tu cuenta, mostrar perfiles y binders, facilitar conexiones, trades, mensajes, comunidades, productos, torneos, notificaciones y seguridad de la plataforma."],
      ["Base legal", "Ejecucion del servicio solicitado, consentimiento cuando corresponda y interes legitimo para seguridad, metricas internas y mejora del producto."],
      ["Con quien se comparte", "Tu contenido publico se muestra a otros usuarios segun la visibilidad elegida. No vendemos datos. Podremos usar proveedores tecnicos de hosting, correo, almacenamiento y analitica si se activan."],
      ["Tus derechos", "Puedes solicitar acceso, rectificacion, supresion, oposicion, limitacion o portabilidad escribiendo al email de contacto."],
      ["Fotos y contenido", "Sube solo imagenes propias o que tengas permiso para publicar. Evita datos sensibles en fotos de cartas, conversaciones o comprobantes."],
      ["Retencion", "Guardamos los datos mientras mantengas la cuenta o sean necesarios para operar la comunidad, resolver incidencias o cumplir obligaciones legales."]
    ]
  },
  terms: {
    title: "Terminos de uso",
    intro: "Cardora es una plataforma para organizar comunidad, coleccion, publicaciones y posibles acuerdos entre usuarios.",
    sections: [
      ["Uso aceptable", "Debes usar Cardora de forma respetuosa, sin fraude, spam, suplantacion, acoso, contenido ilegal ni publicaciones que vulneren derechos de terceros."],
      ["Intereses, acuerdos y encuentros", "Cardora facilita contacto, comunidad y seguimiento de acuerdos, pero cada usuario o tienda es responsable de verificar estado, condiciones, encuentro y acuerdo final."],
      ["Contenido", "Sigues siendo responsable de las cartas, imagenes, textos, comentarios y productos que publiques. Cardora puede retirar contenido reportado o problematico."],
      ["Tiendas", "Una tienda debe aportar informacion real. La verificacion sera un modulo posterior y no implica garantia automatica de Cardora."],
      ["Evolucion del servicio", "Cardora evoluciona de forma continua. Algunas funciones pueden cambiar, activarse progresivamente o limitarse por comunidad."],
      ["Cuenta", "Debes proteger tus credenciales y avisar si detectas uso no autorizado."],
      ["Limitacion", "Cardora no sustituye herramientas oficiales de torneos ni garantiza valoraciones, precios, autenticidad o disponibilidad de cartas."]
    ]
  },
  cookies: {
    title: "Politica de cookies",
    intro: "Usamos cookies y almacenamiento local para que Cardora funcione y, si lo aceptas, para mejorar el producto.",
    sections: [
      ["Necesarias", "Permiten recordar sesion, preferencias basicas y estado de consentimiento. Sin ellas la app web no puede funcionar correctamente."],
      ["Analiticas", "Solo se activan si aceptas. Sirven para entender el uso general, las pantallas visitadas y los errores, sin vender datos."],
      ["Marketing", "Actualmente no deberian estar activas. Si se activan en el futuro, pediremos consentimiento separado."],
      ["Cambiar preferencia", "Puedes borrar el consentimiento desde tu navegador o pedir que agreguemos un panel de preferencias persistente en la cuenta."],
      ["Preferencia por defecto", "Cardora funciona con cookies necesarias y no carga medicion no esencial si la persona la rechaza."]
    ]
  }
};

function LegalPage() {
  const { page = "privacy" } = useParams();
  const content = pages[page] || pages.privacy;

  return (
    <Container className="page-band legal-page">
      <Card className="cardora-card">
        <Card.Body>
          <span className="home-kicker">Cardora legal</span>
          <h1 className="section-title mb-2">{content.title}</h1>
          <p className="muted-copy">{content.intro}</p>
          <div className="legal-switcher">
            <Link to="/legal/privacy">Privacidad</Link>
            <Link to="/legal/terms">Terminos</Link>
            <Link to="/legal/cookies">Cookies</Link>
          </div>
          <div className="legal-sections">
            {content.sections.map(([title, body]) => (
              <section key={title}>
                <h2>{title}</h2>
                <p>{body}</p>
              </section>
            ))}
          </div>
          <p className="legal-note">
            Esta informacion describe el funcionamiento actual de Cardora y puede actualizarse cuando cambien
            el servicio, sus proveedores o las obligaciones aplicables.
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default LegalPage;
